import { Injectable } from '@angular/core';
import {ModalDeleteComponent} from "../components/modals/modal-delete/modal-delete.component";
import {BsModalService} from "ngx-bootstrap/modal";
import {take} from "rxjs/operators";
import {ToastrService} from "ngx-toastr";
import {FormService} from './form.service';

@Injectable({
  providedIn: 'root'
})
export class DeleteService {

  constructor(private modalService: BsModalService,
              private formService: FormService,
              private toastrService: ToastrService) { }

  async confirm(title, name) {
    return new Promise((resolve, reject) => {
      this.modalService.show(ModalDeleteComponent, {
        initialState: {
          title: title,
          name: `${title} ${name}`,
          delete: () => {
            resolve(true);
          },
          cancel: () => {
            reject(false);
          }
        }
      });
    });
  }

  async process(title, name) {
    this.formService.setForceSkipCheck();
    return new Promise((resolve, reject) => {
      const toastr = this.toastrService.info(`Click to cancel deleting the ${title} ${name}`, '', {
        timeOut: 15000,
        extendedTimeOut: 15000,
        progressBar: true,
        progressAnimation: 'increasing',
      });

      const tap$ = toastr.onTap.pipe(take(1)).subscribe(() => {
        hidden$.unsubscribe();
        reject(false);
      });

      const hidden$ = toastr.onHidden.pipe(take(1)).subscribe(() => {
        tap$.unsubscribe();
        resolve(true);
      });
    });
  }
}
